import ajax from '@/utils/ajax';
// 4870367778182072320
export const head = '/web';

export const getActiveDetail = (data) => ajax(
  `${head}/v1/daka/activity/data?activityId=${data.activityId}&isPreview=${data.isPreview}`,
  {},
  'POST',
);

export const getPrizeDetail = (data) => ajax(
  `${head}/v1/daka/activity/prize/${data.activityId}/${data.activityPrizeId}`,
  {},
  'POST',
);

export const givePrize = (data) => ajax(
  `${head}/v1/daka/activity/receive/prize`,
  data,
  'POST',
);
